import { render } from "./MedicalInfoCard.vue?vue&type=template&id=77d5cf44&scoped=true"
import script from "./MedicalInfoCard.vue?vue&type=script&lang=js"
export * from "./MedicalInfoCard.vue?vue&type=script&lang=js"

import "./MedicalInfoCard.vue?vue&type=style&index=0&id=77d5cf44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d5cf44"]])

export default __exports__